/** Regex for a valid integer number. */
export const INTEGER_REGEX = new RegExp(/^(-)?\d*$/)

/** Regex for a valid decimal/float. Accepts both dot(.) and comma(,) as seperators. */
export const DECIMAL_REGEX = new RegExp(/^(-)?\d*([.,]\d*)?$/)

export const PHONE_NUMBER_REGEX = new RegExp(/^(\+?\d{0,5})?\s?[-/]?\s?(\(?[\d\s]*\)?)\s?$/)
